import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-slate-950">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557665/img/image_26t182en.png)] brightness-150" />
        {}
        <div className="absolute inset-0 bg-slate-950/60 mix-blend-multiply" />
        <div className="absolute inset-0 bg-blue-950/40 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/50 to-transparent" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="font-sans text-4xl font-bold tracking-tight text-slate-50 sm:text-5xl md:text-6xl lg:text-7xl lg:leading-[1.1]">Mehr Eigenverbrauch, weniger Stromkosten – Gebäudeautomation im Oberwallis</h1>

          {}
          <p className="mt-6 max-w-2xl text-lg text-slate-300 sm:text-xl md:mt-8">Wir vernetzen PV-Anlage, Wärmepumpe, Speicher und Gebäudetechnik zu einem intelligenten System – damit Sie mehr aus Ihrer Energie herausholen und gleichzeitig mehr Komfort geniessen. Lokal im Oberwallis, zertifiziert von Loxone</p>

          {}
          <div className="mt-10 flex flex-wrap gap-4">
            <Button asChild className="h-12 rounded-lg bg-primary px-8 text-base font-medium text-white shadow-[0_0_20px_rgba(37,99,235,0.3)] transition-all hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(37,99,235,0.5)]">
              <Link to="/ContactPage">Kostenloses Erstgespräch vereinbaren<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Hero.tsx|sig:r623bl" data-ast-start="2176" data-ast-end="2214"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}